import { ApiCaller } from "../../config";

/**
 * Notification Management APIs
 *
 * GET  /admin/notification?limit=&offset=&audience=
 * POST /admin/notification
 *
 * Audience: "SU" | "SP" | "BOTH"
 * sendType: "now" | "schedule" (default "now")
 * scheduledAt: required ISO datetime when sendType is "schedule"
 */

const AUDIENCE_TO_API = {
  "service-users": "SU",
  "service-providers": "SP",
  both: "BOTH",
  SU: "SU",
  SP: "SP",
  BOTH: "BOTH",
};

export const toApiAudience = (audience) =>
  AUDIENCE_TO_API[audience] || audience || "";

export const fetchNotifications = async ({
  limit = 10,
  offset = 0,
  audience = "",
} = {}) => {
  const audienceParam = audience ? toApiAudience(audience) : "";
  const query = `/admin/notification?limit=${limit}&offset=${offset}${
    audienceParam ? `&audience=${audienceParam}` : ""
  }`;
  return ApiCaller.Get(query);
};

export const sendPushNotification = async (payload) => {
  const sendType = payload.sendType || (payload.sendNow === false ? "schedule" : "now");

  const body = {
    title: payload.title,
    message: payload.message,
    audience: toApiAudience(payload.audience),
    sendType,
  };

  if (sendType === "schedule" && payload.scheduledAt) {
    body.scheduledAt = payload.scheduledAt;
  }

  return ApiCaller.Post(`/admin/notification`, body);
};
